export default __webpack_public_path__ + "static/media/idVerification.85dc83d4.svg";